import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { parseISO } from 'date-fns';
import { Subject, Subscription } from 'rxjs';
import { ChangeLogEntry } from 'src/app/services/dtos/changeLogEntry';

@Component({
  selector: 'app-task-audit-trail',
  templateUrl: './task-audit-trail.component.html',
  styleUrls: ['./task-audit-trail.component.scss']
})
export class TaskAuditTrailComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() public taskAuditTrail!: Subject<ChangeLogEntry[]>;

  @ViewChild(MatPaginator) private paginator!: MatPaginator;

  public dataSource: MatTableDataSource<ChangeLogEntry> = new MatTableDataSource();
  public displayedColumns: string[] = ['timeStamp', 'message'];

  private inputSubscription!: Subscription;

  public ngOnInit(): void {
    this.inputSubscription = this.taskAuditTrail.subscribe(auditTrail => {
      this.dataSource.data = auditTrail;
    });
  }

  public ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  public ngOnDestroy(): void {
    this.inputSubscription.unsubscribe();
  }

  public getViewHeight(): number {
    const element = document.getElementById('task-details-header-container');
    if (!element){
      return window.innerHeight / 2;
    }

    return window.innerHeight - element.offsetHeight - 270;
  }

  private convertToChangeLogEntries(changelog: string): ChangeLogEntry[] {
    if (!changelog) {
      return [];
    }
    const records = changelog.split('\r\n');
    const dateLength = 19;
    const messageStartIndex = 22;
    return records.map(x => new ChangeLogEntry(parseISO(x.substring(0, dateLength)), x.substring(messageStartIndex)));
  }
}
